import React from 'react';
import { HStack } from '@chakra-ui/react';
import BackButton from '../../../../modules/BackButton/BackButton';
import { RenderIf } from '../../../../modules/RenderIf/RenderIf';
import InspectionDetailActionMenu from '../InspectionDetailActionMenu';
import InspectionDetailHeaderSummary from './InspectionDetailHeaderSummary';
import { useTokens } from '../../../../../context/TokenProvider';
import navigator from '../../../../../services/ui/navigator';
const InspectionDetailHeader = ({ inspection, isShare, canEditInspection, }) => {
    const tokens = useTokens();
    return (React.createElement(HStack, { "data-testid": "inspection_detail_header", pt: tokens.Spacing04, align: "start", spacing: tokens.Spacing06, pb: tokens.Spacing06 },
        React.createElement(RenderIf, { condition: !isShare },
            React.createElement(BackButton, { onClick: () => {
                    navigator.back(() => navigator.push('/inspections'));
                } }),
            React.createElement(InspectionDetailActionMenu, { inspection: inspection, isViewOnly: false, canEditInspection: canEditInspection })),
        React.createElement(InspectionDetailHeaderSummary, { inspection: inspection })));
};
export default InspectionDetailHeader;
